export default __webpack_public_path__ + "static/media/logo.4d10dec5.svg";